<template>
    <div v-html="html"></div>
</template>

<script>
export const buildDefaultHtml = (props = {}) => (props.html || '');

export default {
    name: 'MailingBlockRaw',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
